import { Box } from "@mui/material";
import "./_style.scss";
import { useContext, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import TkKikoStepper from "../../components/molecules/TkKikoStepper";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkViewButtonJudgement from "../../components/molecules/TkViewButtonJudgement";
import TkTable from "../../components/atoms/TkTable";
import {
  claimHeadTitleList,
  depositHeadTitleList,
  fakeTableList,
  headTitleList,
} from "./parts";
import TkButton from "../../components/atoms/TkButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkMemo from "../../components/molecules/TkMemo";
import {
  funClaimBodyList,
  funClaimBtnBodyList,
  fundepositBodyList,
  fundepositBodyLists,
  funStatusBodyList,
} from "./hooks/useHooks";
import TkRequestIDSelectionDialog from "../../components/molecules/TkRequestIDSelectionDialog";
import {
  httpAPI_APP016,
  httpAPI_REC005,
  httpAPI_REC016,
  httpAPI_REC017,
  httpAPI_REC023,
  httpAPI_REC024,
  httpAPI_REC025,
} from "./api/request";
import { IAPI_APP016_Request, IAPI_REC023_Response } from "../../type/apiType";
import { TkRouteContext } from "../../context/tkRouteContext";
import { ITkViewButtonJudgementStatus } from "../../type/componentsType/TkViewButtonJudgement";
import {
  changeAmountFormat,
  isStatusAfterApproval,
} from "../../utils/useTools";
import TkApprovalDateSymbolNumberRegistrationDialog from "../../components/molecules/TkApprovalDateSymbolNumberRegistrationDialog";
import TkTableWithNoLine from "../../components/molecules/TkTableWithNoLine";
import _ from "lodash";
import {
  BillingTypeFormFacility,
  CommonOrCommonRetirementFlug,
  DepositCategory,
} from "../../assets/data/Constants";
import { IPaymentManagementProps } from "../../type/contextType/businessContext/IPaymentManagement";
import { TkGetCode } from "../../utils/TkGetCode";

/**
 * SCRW160002 入金・請求データ　仕分け処理
 * @return SCRW160002 入金・請求データ　仕分け処理
 */
const SCRW160002 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const { state: stateRouter, setState: setStateRouter } =
    useContext(TkRouteContext);
  const [claimBodyTitleListData, SetClaimBodyTitleListData] = useState<any>([]);
  const [claimBtnBodyTitleListData, SetClaimBtnBodyTitleListData] =
    useState<any>([]);
  const [depositBodyTitleListData, setDepositBodyTitleListData] = useState<any>(
    []
  );
  const [depositKbnData, setDepositKbnData] = useState("");
  const [depositedBodyTitleListData, setDepositedBodyTitleListData] =
    useState<any>([]);
  const [memoData, setMemoData] = useState("");
  const [memoCheck, setMemoCheck] = useState(false);
  const [statecorpInfoList, setStatecorpInfoList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const [statusListData, setStatusListData] = useState<any>([]);
  const [isShow, setIsShow] = useState(false);
  const [pattern1, setPattern1] = useState(false);
  const [pattern2, setPattern2] = useState(false);
  const [pattern3, setPattern3] = useState(false);
  const [pattern4, setPattern4] = useState(false);
  const [pattern5, setPattern5] = useState(false);
  const [dialogData, setDialogData] = useState<any>([]);
  const [SCRW160002RepData, setSCRW160002RepData] = useState<any>();
  const [isOpen, setIsOpen] = useState(false);
  const [bodyList, setBodyList] = useState([]);
  const [isBodylistVisible, setIsBodylistVisible] = useState(false);
  const [currentInvoiceId, setCurrentInvoiceId] = useState(null as any);
  const [tableData, setTableData] = useState<any>({});
  const selectedBillingContractorNo = useRef<any>("");
  const applyId =
    location.state?.applyId ?? businessState.paymentManagement?.applyId;

  useEffect(() => {
    setDepositBodyTitleListData(
      fundepositBodyList(
        tableData.data,
        tableData.disable,
        onGetValue,
        tableData.error
      )
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableData]);

  const handleLinkClick = (data: any) => {
    setBusinessState({
      ...businessState,
      job_13: {
        ...businessState.job_13,
        demanderId: data.invoiceId,
      },
      job_83: {
        ...businessState.job_83,
        demanderId: data.invoiceId,
      },
      paymentManagement: {
        ...businessState.paymentManagement,
        applyId,
      },
    });
    navigate("/SCRW160005");
  };

  const handleBtnClick = async () => {
    // 請求一覧参照API 呼び出し
    try {
      const res = await httpAPI_REC016({
        bankName: businessState.paymentManagement?.fromBankName,
        branchName: businessState.paymentManagement?.fromBranchName,
      });

      if (res.resultCd === "I0000") {
        setDialogData(res.billingList);
        setIsShow(true);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onGetValue = (data: any) => {
    setTableData({ ...tableData, error: false });
    setDepositKbnData(data);
  };

  const handleInit = async () => {
    // 仕分け結果詳細参照API 呼び出し
    try {
      const res = await httpAPI_REC023({ applyId });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        setSCRW160002RepData(res);

        const isBodylistVisible = isStatusAfterApproval(res.statusCd);
        const bodyList: any = [
          [
            {
              children: isBodylistVisible ? res.symbolNo : undefined,
            },
            {
              children: isBodylistVisible ? res.approvalDate : undefined,
            },
          ],
        ];
        setBodyList(bodyList);

        if (
          res.depositKbn === DepositCategory["組戻金（退職手当金一時預かり金）"]
        ) {
          handleScreening(res);
          return;
        }

        setTableData({ data: res, disable: true });
        SetClaimBodyTitleListData(
          funClaimBodyList(handleLinkClick, res, undefined, applyId)
        );
        SetClaimBtnBodyTitleListData(funClaimBtnBodyList(handleBtnClick));

        setStatusListData(funStatusBodyList(res.statusList));

        let resArr = stateFakeTableList.current;

        setStatecorpInfoList(resArr);
        setIsBodylistVisible(isBodylistVisible);
        setPattern3(true);
        setPattern5(true);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleScreening = (
    data: IPaymentManagementProps | IAPI_REC023_Response
  ) => {
    let stateData = data?.sortingStatus; // 仕分け処理状態
    let kbnData: any = data?.depositKbn; // 入金区分
    if (stateData === "0" && !kbnData) {
      // 仕分け待ち
      setPattern1(true);
      setPattern5(true);
      SetClaimBtnBodyTitleListData(funClaimBtnBodyList(handleBtnClick));
      setTableData({ data, disable: false });
    } else if (stateData === "1") {
      if (kbnData === "7") {
        // 不着明細
        setPattern2(true);
        let resArr = stateFakeTableList.current;
        resArr.find((item) => item.keyword === "depositId")!.text =
          data.depositId;
        resArr.find((item) => item.keyword === "number")!.text = data.depositNo;
        resArr.find((item) => item.keyword === "transactionDate")!.text =
          data.depositDate;
        resArr.find((item) => item.keyword === "depositAmount")!.text =
          changeAmountFormat(data.depositAmt ?? 0) + "円";
        resArr.find((item) => item.keyword === "summary")!.text =
          data.fromRequesterName;
        resArr.find((item) => item.keyword === "bank")!.text =
          (data.fromBankName ?? "") + "/" + (data.fromBranchName ?? "");
        resArr.find((item) => item.keyword === "kbn")!.wantToSetValue =
          data.depositKbn;
        resArr.find((item) => item.keyword === "kbn")!.disabled = true;
        resArr.find((item) => item.keyword === "reason")!.wantToSetValue =
          data.nonDeliveryReason;
        resArr.find((item) => item.keyword === "reason")!.disabled = true;
        resArr.find((item) => item.keyword === "contractorName")!.text =
          (data.billingContractorNo ? data.billingContractorNo + ":" : "") +
          (data.billingContractorName ?? "");
        resArr.find((item) => item.keyword === "aidedContractorName")!.text =
          (data.billingStaffNo ? data.billingStaffNo + ":" : "") +
          (data.billingStaffName ?? "");
        setStatecorpInfoList(resArr);
      } else if (
        kbnData === "1" ||
        kbnData === "2" ||
        kbnData === "3" ||
        kbnData === "4" ||
        kbnData === "5" ||
        kbnData === "6" ||
        kbnData === "8" ||
        kbnData === "12"
      ) {
        // 請求紐付け済み
        setPattern3(true);
        setPattern5(true);
        SetClaimBodyTitleListData(funClaimBodyList(handleLinkClick, data));
        setTableData({ data, disable: true });
      } else if (
        kbnData === "9" ||
        kbnData === "10" ||
        kbnData === "11" ||
        kbnData === "13" ||
        kbnData === "14" ||
        kbnData === "15" ||
        kbnData === "16"
      ) {
        // 手動振り分け済み
        setPattern5(true);
        setTableData({ data, disable: true });
      }
    }
  };

  useEffect(() => {
    if (applyId) {
      handleInit();
    } else {
      handleScreening(businessState.paymentManagement!);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onChange = (event: any) => {
    if (event.target.type === "input") {
      setMemoData(event.target.value);
    }
    if (event.target.type === "checkbox") {
      setMemoCheck(event.target.value);
    }
  };

  const btnEvent = async (btnName: any) => {
    const num =
      btnName === "郵送"
        ? "11"
        : btnName === "受理"
        ? "2"
        : btnName === "承認"
        ? "3"
        : btnName === "担当者に差戻し"
        ? "8"
        : btnName === "課長代理確認"
        ? "14"
        : btnName === "上長承認"
        ? "6"
        : null;
    if (num === null) {
      return;
    }

    if (num === "3") {
      setIsOpen(true);
      return;
    }

    let reqData: IAPI_APP016_Request = makeHttpObj(num);

    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleOnSuccess = async (data: any) => {
    SetClaimBtnBodyTitleListData(
      funClaimBodyList(handleLinkClick, {
        ...data,
        billingKbn: data.invoiceKbnCd,
      })
    );
    setCurrentInvoiceId(data.invoiceId);
    selectedBillingContractorNo.current = data?.billingContractorNo ?? "";

    // 入金一覧参照API 呼び出し
    try {
      const res = await httpAPI_REC017({
        invoiceId: data.invoiceId,
        invoiceClass: data.invoiceKbnCd,
      });

      if (res.resultCd === "I0000") {
        setDepositedBodyTitleListData(
          fundepositBodyLists(res.depositDataList, true, onGetValue)
        );
        const depositKbn =
          data.invoiceKbnCd === BillingTypeFormFacility["退職手当金返還金"]
            ? DepositCategory["退職手当金返還金"]
            : data.invoiceKbnCd === BillingTypeFormFacility["都道府県補助金"]
            ? DepositCategory["都道府県補助金"]
            : data.invoiceKbnCd;
        setTableData({
          data: {
            ...tableData.data,
            depositKbn,
          },
          disable: true,
        });
        setDepositKbnData(depositKbn);
        if (res.depositDataList!.length > 0) {
          setPattern4(true);
        }
        setIsShow(false);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const getBackUrl = () => {
    // API呼び出しの結果、正常終了した場合 遷移元画面に戻る
    let routerList = stateRouter.routerList || [];

    if (routerList.length > 1) {
      setStateRouter({
        ...state,
        routerList: [...routerList.slice(0, routerList.length - 1)],
      });

      const burl = `${routerList[routerList.length - 2].href}`;

      return navigate(burl);
    } else {
      // エラー内容を表示する。
      setStateRouter({
        ...state,
        routerList: [...[]],
      });
      navigate("/error");
    }
  };

  const handleDoCancelClick = async () => {
    // 仕分け処理解除更新API 呼び出し
    try {
      const res = await httpAPI_REC024({
        depositId: businessState.paymentManagement?.depositId,
        wamInvoiceId: businessState.paymentManagement?.invoiceId,
        contractorNo: businessState.paymentManagement?.billingContractorNo,
      });

      if (res.resultCd === "I0000") {
        SetClaimBtnBodyTitleListData(funClaimBtnBodyList(handleBtnClick));

        let data = businessState.paymentManagement ?? {};
        data.depositKbn = "";
        setTableData({ data, disable: false });

        setPattern1(true);
        setPattern2(false);
        setPattern3(false);
        setPattern4(false);
        setPattern5(true);
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleDoClick = async () => {
    if (!depositKbnData) {
      setTableData({ ...tableData, error: true });
      return;
    }
    setTableData({ ...tableData, error: false });

    // 仕分け処理更新API 呼び出し
    try {
      const res = await httpAPI_REC005({
        contractorNo: selectedBillingContractorNo.current,
        invoiceId: currentInvoiceId,
        depositId: businessState?.paymentManagement?.depositId,
        depositKbn: depositKbnData,
        screenId: "SCRW160002",
      });

      if (res.resultCd === "I0000") {
        getBackUrl();
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSendToOther = async () => {
    try {
      const res = await httpAPI_REC025({
        depositId: businessState?.paymentManagement?.depositId,
      });
      if (res.resultCd === "I0000") {
        getBackUrl();
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const handleSave = async (formData: any) => {
    let reqData: IAPI_APP016_Request = makeHttpObj("3", formData);
    try {
      const res = await httpAPI_APP016({
        ...reqData,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRW110001");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const setOpen = () => {
    setIsOpen(false);
  };

  const makeHttpObj = (num: string, formData?: any): IAPI_APP016_Request => {
    const req: IAPI_APP016_Request = {
      applyId,
      applyEvent: num,
      contractorNo: SCRW160002RepData.billingContractorNo,
      screenId: "SCRW160002",
      inquiryCode: memoCheck ? "1" : "0",
      reason: memoData,
    };
    if (formData?.symbolNumber) {
      req.symbolNo =
        TkGetCode(CommonOrCommonRetirementFlug, formData.symbolNumberType) +
        "第" +
        formData.symbolNumber +
        "号";

      req.transferDueDateForGroupApply = formData.scheduledPaymentDate;
    }

    return req;
  };

  return (
    <Box className="SCRW160002" data-testid="SCRW160002PageForTest">
      {applyId && (
        <TkKikoStepper
          applicationFlowType="TYPE2"
          businessType={businessState.common?.businessType}
          applicationStatus={
            SCRW160002RepData?.statusCd! as ITkViewButtonJudgementStatus
          }
          corporateApplicationClassification={undefined}
        />
      )}

      {pattern3 && (
        <TkTable
          headList={claimHeadTitleList}
          bodyList={[claimBodyTitleListData]}
          showUnit={true}
          headerLeftComponent={"【請求データ】"}
        />
      )}

      {pattern1 && (
        <TkTable
          headList={claimHeadTitleList}
          bodyList={[claimBtnBodyTitleListData]}
          showUnit={true}
          headerLeftComponent={"【請求データ】"}
        />
      )}

      {pattern5 && (
        <TkTable
          headList={depositHeadTitleList}
          bodyList={depositBodyTitleListData}
          showUnit={true}
          headerLeftComponent={"【入金データ】"}
        />
      )}

      {pattern4 && (
        <TkTable
          headList={depositHeadTitleList}
          bodyList={depositedBodyTitleListData}
          showUnit={true}
          headerLeftComponent={"【既存入金データ】"}
        />
      )}

      {pattern2 && (
        <TkFakeTable
          list={statecorpInfoList}
          ruleSchema={{}}
          showButton={false}
        />
      )}

      <TkMemo showTable={true} bodyList={statusListData} onChange={onChange} />
      {isBodylistVisible && (
        <TkTableWithNoLine headList={headTitleList} bodyList={bodyList} />
      )}

      <Box className="button">
        <TkBackButton />
        {!applyId && (
          <>
            {pattern1 ? (
              <>
                <TkButton onClick={handleDoClick}>仕分け処理</TkButton>
                <TkButton onClick={handleSendToOther}>
                  機構他口座に振替
                </TkButton>
              </>
            ) : (
              <TkButton onClick={handleDoCancelClick}>仕分け処理解除</TkButton>
            )}
          </>
        )}

        {applyId && (
          <TkViewButtonJudgement
            Status={SCRW160002RepData?.statusCd}
            flowType={"TYPE2"}
            businessType={businessState.common?.businessType}
            onClick={btnEvent}
          />
        )}
      </Box>
      <TkRequestIDSelectionDialog
        open={isShow}
        onSuccess={(data) => handleOnSuccess(data)}
        onClose={() => setIsShow(false)}
        transactionDate={businessState.paymentManagement?.depositDate ?? ""}
        depositAmount={businessState.paymentManagement?.depositAmt ?? 0}
        summary={businessState.paymentManagement?.fromRequesterName ?? ""}
        bankBranch={
          businessState.paymentManagement?.fromBankName &&
          businessState.paymentManagement?.fromBranchName
            ? (businessState.paymentManagement?.fromBankName ?? "") +
              "/" +
              (businessState.paymentManagement?.fromBranchName ?? "")
            : ""
        }
        wantToSetValue={dialogData}
      />
      <TkApprovalDateSymbolNumberRegistrationDialog
        open={isOpen}
        onSuccess={handleSave}
        onClose={setOpen}
        isScheduledPaymentDateVisible={false}
      />
    </Box>
  );
};

export default SCRW160002;
